export default "__VITE_ASSET__DUXaN8H9__"